import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import MenuAccordian from "./MenuAccordian";
// import PlayModeSelector from "./playMode.js";
// import MyPresetAuthManager from "../MyPresetManager/MyPresetAuthManager.js";
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      style={{
        justifyContent: "center",
        display: "flex",
        // backgroundColor: "#bbaef2",
      }}
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function MenuTabs(props) {
  const [value, setValue] = React.useState(1);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div
        style={{
          width: "90%",
          height: "500px",
          maxWidth: "500px",
          backgroundColor: "#e9e9e9",

          borderRadius: "15px",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              centered
            >
              {/* <Tab label="play Mode" {...a11yProps(0)} /> */}
              <Tab label="Presets" {...a11yProps(0)} />
              {/* <Tab label="My Presets" {...a11yProps(2)} /> */}
            </Tabs>
          </Box>
          {/* <CustomTabPanel value={value} index={0}>
            <PlayModeSelector></PlayModeSelector>
          </CustomTabPanel> */}
          <CustomTabPanel value={value} index={1}>
            <MenuAccordian
              setTaskName={props.setTaskName}
              setIsMenuOn={props.setIsMenuOn}
              addTasksToList={props.addTasksToList}
            ></MenuAccordian>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <div
              style={{
                // display: "flex",
                // justifyContent: "center",
                // alignItems: "center", // Centers vertically
                // backgroundColor: "lightgray",
                // backgroundColor: "gray",
                // backgroundColor: "gray",

                backgroundColor: "white",
                width: "85vw", // Ensures it spans the full width of the viewport
                maxWidth: "450px",
                height: "70vh", // Ensures it spans the full height of the viewport
                maxHeight: "400px",
                overflow: "auto",
                borderRadius: "15px",
              }}
            >
              <div
                style={{
                  //   width: "90%", // Occupies 90% of the device width
                  //   height: "80%", // Occupies 80% of the device height
                  padding: "10px",
                  borderRadius: "5px",
                  //   margin: "5px",
                  backgroundColor: "white",

                  // boxShadow: "0 2px 10px rgba(0,0,0,0.2)", // Optional for better look
                }}
              >
                {/* <MyPresetAuthManager
                  setTaskName={props.setTaskName}
                  setIsMenuOn={props.setIsMenuOn}
                  addTasksToList={props.addTasksToList}
                  user={props.user}
                  setUser={props.setUser}
                  tasks={props.tasks}
                ></MyPresetAuthManager> */}
              </div>
            </div>
          </CustomTabPanel>
        </Box>
      </div>
    </div>
  );
}

// Arena
